/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import SpecialityForm from '@modules/admin/speciality/Speciality.Form'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import { useTranslation } from 'react-i18next'
import { useParams, Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import Loading from '@modules/core/components/Loading'
import { history } from '@services/History'
import { createSpecialityRequestBody, formatSpecialityType } from '@modules/admin/speciality/actions'
import { displayLocaleName, languageCodes } from './specialty.utils'

const SpecialityEdit = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const [speciality, setSpeciality] = useState({
    translations: [
      { locale: 'ar', name: '' },
      { locale: 'es', name: '' },
      { locale: 'en', name: '' },
      { locale: 'it', name: '' },
      { locale: 'pt', name: '' },
      { locale: 'tr', name: '' },
      { locale: 'ca', name: '' },
    ],
  })

  const [addingNewLanguage, setAddingNewLanguage] = useState(false)
  const [loading, setLoading] = useState(false)
  const fetchSpeciality = async () => {
    setLoading(true)
    try {
      const { data } = await Consultations.speciality.show(id)
      setSpeciality({ ...data, type: formatSpecialityType(data.type) })
    } catch (e) {
      console.error(e.message)
    }
    setLoading(false)
  }
  useEffect(() => {
    if (id) {
      fetchSpeciality()
    }
  }, [])
  const onSubmit = async (values) => {
    try {
      const requestBody = createSpecialityRequestBody(values)
      if (id) await Consultations.speciality.update(id, requestBody)
      else await Consultations.speciality.store(requestBody)
      history.push('/speciality')
    } catch (e) {
      console.error(e.message)
    }
  }

  const onAddLanguage = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    const locale = formData.get('locale')
    if (typeof locale === 'string' && languageCodes.includes(locale as (typeof languageCodes)[number])) {
      setAddingNewLanguage(true)
      setSpeciality((prevState) => ({
        ...prevState,
        translations: [...prevState.translations, { locale, name: displayLocaleName.of(locale) || 'Unknown' }],
      }))
      setTimeout(() => {
        setAddingNewLanguage(false)
      }, 1000)
    }
  }

  const headerTitle = id ? t('Editar Especialidad') : t('Nueva especialidad')
  return (
    <div className="crud-wrapper">
      <DashboardHeader title={headerTitle}>
        <Link className="btn btn-primary" to={`/speciality`}>
          {t('Volver')}
        </Link>
      </DashboardHeader>
      <div className="container-fluid main-content">
        {loading ? (
          <Loading isFetching />
        ) : (
          <>
            <form
              className="md-form"
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                marginBottom: '20px',
              }}
              onSubmit={onAddLanguage}
            >
              <select name="locale">
                {languageCodes.map((code) => (
                  <option key={code} value={code}>
                    {`(${code}) ${displayLocaleName.of(code) || 'Unknown'}`}
                  </option>
                ))}
              </select>
              <button type="submit">
                {t('specialty.add_language', {
                  defaultValue: 'Añadir Idioma',
                })}
              </button>
            </form>
            {addingNewLanguage && <Loading isFetching />}
            {!addingNewLanguage && <SpecialityForm onSubmit={onSubmit} initialValues={speciality} />}
          </>
        )}
      </div>
    </div>
  )
}
export default SpecialityEdit
